import { hasProp } from "../../../helpers/Class";
import i18n from "../../../i18n";
import DistributionAddress from "../DistributionAddress";

class Bookseller {
    // eslint-disable-next-line max-lines-per-function
    constructor(bookseller = null) {
        this._id = !hasProp(bookseller, "_id") ? undefined : bookseller._id;
        this.email = !hasProp(bookseller, "email") ? undefined : bookseller.email;
        this.password = !hasProp(bookseller, "password") ? undefined : bookseller.password;
        this.society = !hasProp(bookseller, "society") ? undefined : bookseller.society;
        this.firstName = !hasProp(bookseller, "firstName") ? undefined : bookseller.firstName;
        this.lastName = !hasProp(bookseller, "lastName") ? undefined : bookseller.lastName;
        this.mobilePhone = !hasProp(bookseller, "mobilePhone") ? undefined : bookseller.mobilePhone;
        this.addresses = !hasProp(bookseller, "addresses") ? [] : bookseller.addresses.map(address => ({
            ...new DistributionAddress(address),
            gln: !hasProp(address, "gln") ? undefined : address.gln,
            vatin: !hasProp(address, "vatin") ? undefined : address.vatin,
            mobilePhone: !hasProp(address, "mobilePhone") ? undefined : address.mobilePhone,
        }));
        this.publishers = {
            agreements: !hasProp(bookseller, "publishers.agreements") ? [] : bookseller.publishers.agreements,
        };
        this.carriers = {
            agreements: !hasProp(bookseller, "carriers.agreements") ? [] : bookseller.carriers.agreements,
            privates: !hasProp(bookseller, "carriers.privates") ? [] : bookseller.carriers.privates,
        };
        this.active = !hasProp(bookseller, "active") ? undefined : bookseller.active;
        this.isAdmin = !hasProp(bookseller, "isAdmin") ? undefined : bookseller.isAdmin;
        this.createdAt = !hasProp(bookseller, "createdAt") ? undefined : bookseller.createdAt;
        this.updatedAt = !hasProp(bookseller, "updatedAt") ? undefined : bookseller.updatedAt;
        this.connectedAt = !hasProp(bookseller, "connectedAt") ? undefined : bookseller.connectedAt;
        this.accountingNumber = !hasProp(bookseller, "accountingNumber") ? undefined : bookseller.accountingNumber;
        this.discounts = {
            default: !hasProp(bookseller, "discounts.default") ? undefined : bookseller.discounts.default,
            customs: !hasProp(bookseller, "discounts.customs") ? [] : bookseller.discounts.customs,
        };
        this.preferences = {
            billing: {
                method: !hasProp(bookseller, "discounts.preferences.billing.method") ? undefined : bookseller.preferences.billing.method,
                addressId: !hasProp(bookseller, "discounts.preferences.billing.addressId") ? undefined : bookseller.preferences.billing.addressId,
            },
            delivery: {
                method: !hasProp(bookseller, "discounts.preferences.delivery.method") ? undefined : bookseller.preferences.delivery.method,
                addressId: !hasProp(bookseller, "discounts.preferences.delivery.addressId") ? undefined : bookseller.preferences.delivery.addressId,
                carrierId: !hasProp(bookseller, "discounts.preferences.delivery.carrierId") ? undefined : bookseller.preferences.delivery.carrierId,
            },
        };
    }

    get activeStatus() {
        if (this.active) {
            return "active";
        } else if (!this.connectedAt) {
            return "notActivatedYet";
        } else {
            return "blocked";
        }
    }

    get activeStatusLabel() {
        return i18n.t(`class.Bookseller.activeStatus.${this.activeStatus}`);
    }

    getFullName(shopType) {
        const name = shopType === "B2B" ? this.society : `${this.firstName} ${this.lastName}`;
        return name ? name : i18n.t("class.Bookseller.fullName.unknown");
    }
}

export default Bookseller;